import { registerAPIService } from './APIServicesRegistry';
import APIServiceBase from './APIServiceBase';

export default class TWSCustomerApiService extends APIServiceBase {
    constructor() {
        super('TWSCustomer')
    }

    create(data: any) {
        return this.post('create', data)
    }

    edit(data: any) {
        return this.post('edit', data)
    }

    delete(id: any) {
        return this.get('delete?id=' + id, {})
    }

    copy(id: any) {
        return this.get('copy?id=' + id, {})
    }
}

registerAPIService(TWSCustomerApiService)